import { instance } from "./apiClient";

export const categoriesApi = {
  getCategories: (kind) =>
    instance.get(`/api/categories?kind=${kind}`).then((res) => res.data),

  createCategory: (payload) =>
    instance.post("/api/categories", payload).then((res) => res.data),

  updateCategory: (id, payload) =>
    instance.put(`/api/categories/${id}`, payload).then((res) => res.data),

  deleteCategory: (id) =>
    instance.delete(`/api/categories/${id}`).then((res) => res.data),
};
